var map = {
	"./foundation_login_logo.png": 70418,
	"./hetu_login_logo.png": 9625,
	"./hn_login_logo.png": 81449,
	"./sunward-login-bg.png": 15776,
	"./sunward-login-logo.png": 26257,
	"./xa_login_logo.png": 89441
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31371;